/**
 * Variant matrix used for Google Fonts CSS2 API (`ital,wght` axis).
 * Includes normal + italic styles for all common weights.
 */
const GOOGLE_FONT_VARIANTS =
  'ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900';

/**
 * Font families that are already bundled by the app and should not be requested again.
 */
const APP_BUNDLED_FONTS = new Set(['roboto']);

/**
 * Decides whether a Google Fonts `<link>` should be created for the font family.
 *
 * @param fontName Google font name.
 * @returns `true` when the font should be loaded from Google Fonts.
 */
export function shouldLoadGoogleFont(fontName: string): boolean {
  return !APP_BUNDLED_FONTS.has(fontName.trim().toLowerCase());
}

/**
 * Creates Google Fonts stylesheet URL for a family with broad variant coverage.
 *
 * @param fontName Google font name.
 * @returns URL for loading the font family from Google Fonts CSS2 endpoint.
 */
export function toGoogleFontHref(fontName: string): string {
  const family = fontName.trim().replace(/\s+/g, '+');
  return `https://fonts.googleapis.com/css2?family=${family}:${GOOGLE_FONT_VARIANTS}&display=swap`;
}
